/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_SyncInputs */

const cs_action_sync = /** @type {(inputs: Action_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat na Sreality`)
};

const en_action_sync = /** @type {(inputs: Action_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to Sreality`)
};

/**
* | output |
* | --- |
* | "Sync to Sreality" |
*
* @param {Action_SyncInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_sync = /** @type {((inputs?: Action_SyncInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_SyncInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_sync(inputs)
	return cs_action_sync(inputs)
});